import React from 'react'
import injectSheet from 'react-jss'

const style = theme => ({
    countIconStyle: {
        background: '#000000',
        position: 'absolute',
        bottom: '5%',
        right: '5%',
        opacity: 0.6,
        borderRadius: '16px',
        padding: '4px',
        width: '48px',
        height: '20px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        color: 'white',
        transition: '0.5s ease-in-out',
    },

    countValueStyle: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
    },

    imgStyle: {
        width: '16px',
        height: '12px',
    },

    countStyle: {
        position: 'absolute',
        bottom: '5%',
        right: '5%',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        background: '#000000',
        color: 'white',
        opacity: 0.6,
        borderRadius: '16px',
        padding: '4px',
        width: '34px',
        height: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: '0.5s ease-in-out',
    },
})

const Thumbnail = ({ url, count, hover, img, classes, thumbClick }) => {
    return (
        <div onClick={thumbClick} style={{ backgroundImage: `url("${url}")` }}>
            {hover ? (
                <span className={classes.countIconStyle}>
                    <span className={classes.countValueStyle}>{count}</span>
                    <span>
                        <img src={img} className={classes.imgStyle} />
                    </span>
                </span>
            ) : (
                <span className={classes.countStyle}>+{count}</span>
            )}
        </div>
    )
}

Thumbnail.defaultProps = {
    thumbClick: () => {},
}

export default injectSheet(style)(Thumbnail)
